import React, { useContext } from 'react'
import { Helmet } from 'react-helmet'
import { MainLogo } from '../../../helper/imagepath'
import { Controller, useForm } from 'react-hook-form'
import { PROJECT_TITLE } from '../../../util/constant'
import { yupResolver } from '@hookform/resolvers/yup'
import { forgotPasswordSchema } from '../../../util/validationSchema'
import { useNavigate } from 'react-router-dom'
import { SpinnerContext } from '../../../context/spinnerContext'
import { useDispatch } from 'react-redux'
import { forgotPassword } from '../../../redux/slices/authSlice'
import { errorToast, successToast } from '../../../util/Toast/toast'

const ForgotPassword = () => {
  const { changeLoader } = useContext(SpinnerContext)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(forgotPasswordSchema)
  })

  const onSubmit = async (data) => {
    if (data) {
      changeLoader(true)
      dispatch(forgotPassword(data)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          successToast(payload?.data?.status_message || 'Success!')
          changeLoader(false)
          // payload?.data?.forgotPasswordToken
          // navigate(`/reset-password/${payload?.data?.forgotPasswordToken}`)
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  return (
    <>
      <Helmet>
        <title>{PROJECT_TITLE}</title>
        <link rel="icon" href={''}></link>
      </Helmet>
      <div className="auth-wrapper-main">
        <div className="auth-container">
          <div className="text-center">
            <img
              className="img-fluid auth_logo"
              src={MainLogo}
              onError={(event) => {
                event.target.src = MainLogo
              }}
              alt="Logo"
            />
          </div>

          <div className="authbox">
            <div className="auth-left">
              <div className="auth-page-title">Forgot Password</div>

              <p className="auth-page-sub-title">Enter your email to get a password reset link</p>

              <div className="auth-form-content">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-group input_text">
                    <label className="form-control-label">Email</label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control  ${errors?.email ? 'error-input' : ''}`}
                          type="text"
                          value={value || ''}
                          onChange={onChange}
                          autoComplete="false"
                          // ref={emailRem}
                        />
                      )}
                    />

                    <small>{errors?.email?.message}</small>
                  </div>

                  <div className="auth-btn-div">
                    <button className="btn" type="submit">
                      Send
                    </button>
                    <button className="btn mt-3 outline-btn" type="button" onClick={() => navigate('/login')}>
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="auth-right auth-forgot-pwd-bg-img"></div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ForgotPassword
